import { render } from "./Close.vue?vue&type=template&id=8d1e47a8"
import script from "./Close.vue?vue&type=script&lang=js"
export * from "./Close.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Close.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8d1e47a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8d1e47a8', __exports__)) {
    api.reload('8d1e47a8', __exports__)
  }
  
  module.hot.accept("./Close.vue?vue&type=template&id=8d1e47a8", () => {
    api.rerender('8d1e47a8', render)
  })

}


export default __exports__